import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';

@Component({
  selector: 'ultra-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  static lastPosition = '';
  static categoryOrientationY: number = 0;
  static subCategoryOrientationY: number = 0;
  static quantityElements: number = 0;
  static isActivedCategory: boolean = false;
  static index?: number;

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
  ) {
    this.addListeners();
  }

  ngOnInit() {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    // localStorage.clear();
    // sessionStorage.clear();
  }

  addListeners() {
    addEventListener('wheel', (event) => {
      this.handleNavigation(event);
    })

    addEventListener('click', () => {
      if (AppComponent.isActivedCategory) {
        AppComponent.isActivedCategory = false;
        this.setScroll();
      }
    })
  }

  setScroll() {
    var body = document.getElementById('body');
    var header = <HTMLElement>document.getElementsByClassName('fixed')[0];

    body.style.overflowY = 'scroll';
    body.style.margin = '0px';
    header.style.marginRight = '0px';
  }

  handleNavigation = (e) => {
    if (AppComponent.isActivedCategory) {

      let categoryList = document.getElementById('category-list');
      let extra = 0;
      if (AppComponent.index) {
        let subCategoryList = document.getElementById('sub-category-list-' + AppComponent.index);
        extra = subCategoryList.clientHeight;
      }

      if ((e.deltaY < 0) && (AppComponent.categoryOrientationY < 0)) {
        AppComponent.categoryOrientationY = AppComponent.categoryOrientationY + 40;
      } else if ((e.deltaY > 0) && ((extra > 0 ? Number(AppComponent.lastPosition.replace(/\D/g, '')) + extra : categoryList.clientHeight) > -AppComponent.categoryOrientationY + 300)) {
        AppComponent.categoryOrientationY = AppComponent.categoryOrientationY - 40;
      }

      const containers = document.getElementById('menu');
      containers.style.transform = `translateY(${AppComponent.categoryOrientationY}px)`;
    };
  }
}

